// src/hooks/usePasskeyCheck.js

import { useState, useEffect, useRef } from "react";
import {
  checkPasskeyStatus,
  shouldShowPasskeyDialog,
} from "../utils/passkeyUtils";

/**
 * Custom hook to check passkey status and manage dialog state
 * @param {string} accessToken - User's Cognito access token
 * @param {boolean} isAuthenticated - Whether user is authenticated
 * @param {string} region - AWS region (optional)
 * @returns {Object} { showDialog, setShowDialog, isChecking, hasPasskey }
 */
export const usePasskeyCheck = (accessToken, isAuthenticated, region) => {
  const [showDialog, setShowDialog] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const [hasPasskey, setHasPasskey] = useState(false);
  const checkDone = useRef(false);

  useEffect(() => {
    const performCheck = async () => {
      // Only check once per session when user is authenticated
      if (!isAuthenticated || !accessToken || checkDone.current) {
        return;
      }

      setIsChecking(true);
      checkDone.current = true;

      console.log("Checking passkey status...");
      const { hasPasskey: passkeyExists, error } = await checkPasskeyStatus(
        accessToken,
        region,
      );

      setHasPasskey(passkeyExists);
      setIsChecking(false);

      // Determine if dialog should be shown
      if (shouldShowPasskeyDialog(passkeyExists, error)) {
        console.log("No passkey found, showing dialog");
        setShowDialog(true);
      } else {
        // console.log("Passkey check complete - no dialog needed");
      }
    };

    performCheck();
  }, [accessToken, isAuthenticated, region]);

  return {
    showDialog,
    setShowDialog,
    isChecking,
    hasPasskey,
  };
};

export default usePasskeyCheck;
